app.filter('stripExternalLinks', function() {
    return function(str) {
      return str.replace(/<link/ig, '<link disabled');
    }
});